// extracted by mini-css-extract-plugin
export default {"file":"InputFileApp_file__mF9jF","input":"InputFileApp_input__Vo89i"};